import crossIcon from "src/assets/cross.svg";
import { useState } from "react";
import { useToast } from "src/hooks/useToast";
import { closeInvoiceEscalation } from "src/services/invoice-api";
import { Button } from "src/components";

interface InvoiceAcceptProps {
    onCloseModal: () => void;
    onSuccess: () => void;
    invoiceData: any;
    action: string;
}

const InvoiceEscalationAction = ({ onCloseModal, onSuccess, invoiceData, action }: InvoiceAcceptProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const { toast } = useToast();

    const handleResolveInvoice = async () => {
        setIsLoading(true);
        const payload = {
            "id": invoiceData?.id,
            "status": action === "reject" ? "rejected" : "resolved"
        }

        try {
            await closeInvoiceEscalation(payload, 0);
            toast({ description: "Invoice " + (action === "reject" ? "rejected" : "resolved") + " successfully", variant: "default" });
            onCloseModal();
            onSuccess();
        } catch (error: any) {
            toast({ description: error?.response?.data?.message, variant: "destructive" });
        } finally {
            setIsLoading(false);
            onCloseModal();
        }
    };

    return (
        <div className="flex flex-col gap-y-2 w-[345px] mx-auto bg-white px-6 py-4 border border-gray-300 shadow-lg rounded-xl">
            <div className="flex justify-between items-center">
                <p className="text-normal py-1 font-semibold text-[#1B1A1F]">{action === "reject" ? "Reject Invoice" : "Accept Invoice"}</p>
                <Button className="bg-transparent -mr-3" onClick={onCloseModal}>
                    <img src={crossIcon} alt="cross" className="w-5 h-5 font-bold invert cursor-pointer" />
                </Button>
            </div>
            <p className="text-sm mt-2 font-normal text-[#666666] mb-2">Are you sure you want to {action === "reject" ? "reject" : "accept"} this invoice?</p>
            {/* <label className="text-sm mt-2 font-normal text-[#666666]">Select Status</label> */}
            {/* <Autocomplete onSelectionChange={(value: any) => setStatus(value)} placeholder="Select Status" suggestionList={[{ label: "Closed", value: "closed" }, { label: "Pending", value: "pending" }]} displayKey="label" uniqueKey="value" /> */}
            {/* <label className="text-sm mt-2 font-normal text-[#666666]">Enter remarks</label> */}
            {/* <Input placeholder="Enter remarks" value={remarks} onChange={(e) => setRemarks(e.target.value)} className="py-2 border border-gray-300 rounded-md" /> */}

            <div className="flex justify-end gap-2 mt-4">
                <Button className="w-fit h-9 mt-0 font-normal border border-[#D0D0D0]  bg-[#F1F1F1] shadow-sm" onClick={onCloseModal}>
                    Cancel
                </Button>
                <Button
                    loaderSize="small"
                    isLoading={isLoading}
                    className="text-white bg-[#8051FF] hover:bg-[#6E3DFF] px-4 py-2 rounded-lg"
                    onClick={handleResolveInvoice}
                >
                    {action === "reject" ? "Reject" : "Accept"}
                </Button>
            </div>

        </div>
    );
};

export default InvoiceEscalationAction;
